import * as React from "react";
import { createModule } from "../config.js";
import { useEventCallback, useRTL } from "../hooks/index.js";
import { cssClass, label as translateLabel } from "../utils.js";
import { IconButton, NextIcon, PreviousIcon } from "../components/index.js";
import { useEvents, useLightboxState } from "../contexts/index.js";
import { useController } from "./Controller.js";
import { ACTION_NEXT, ACTION_PREV, EVENT_ON_KEY_DOWN, MODULE_NAVIGATION, VK_ARROW_LEFT, VK_ARROW_RIGHT } from "../consts.js";
export var NavigationButton = function NavigationButton(_ref) {
  var publish = _ref.publish,
      labels = _ref.labels,
      label = _ref.label,
      icon = _ref.icon,
      renderIcon = _ref.renderIcon,
      action = _ref.action,
      disabled = _ref.disabled;
  return React.createElement(IconButton, {
    label: translateLabel(labels, label),
    icon: icon,
    renderIcon: renderIcon,
    className: cssClass("navigation_".concat(action)),
    disabled: disabled,
    "aria-disabled": disabled,
    onClick: function onClick() {
      publish(action);
    }
  });
};
export var Navigation = function Navigation(_ref2) {
  var slides = _ref2.slides,
      finite = _ref2.carousel.finite,
      labels = _ref2.labels,
      _ref2$render = _ref2.render,
      buttonPrev = _ref2$render.buttonPrev,
      buttonNext = _ref2$render.buttonNext,
      iconPrev = _ref2$render.iconPrev,
      iconNext = _ref2$render.iconNext;

  var _useLightboxState = useLightboxState(),
      currentIndex = _useLightboxState.state.currentIndex;

  var _useController = useController(),
      subscribeSensors = _useController.subscribeSensors;

  var _useEvents = useEvents(),
      publish = _useEvents.publish;

  var isRTL = useRTL();
  var handleKeyDown = useEventCallback(function (event) {
    if (event.key === VK_ARROW_LEFT) {
      publish(isRTL ? ACTION_NEXT : ACTION_PREV);
    } else if (event.key === VK_ARROW_RIGHT) {
      publish(isRTL ? ACTION_PREV : ACTION_NEXT);
    }
  });
  React.useEffect(function () {
    return subscribeSensors(EVENT_ON_KEY_DOWN, handleKeyDown);
  }, [subscribeSensors, handleKeyDown]);
  return React.createElement(React.Fragment, null, buttonPrev ? buttonPrev() : React.createElement(NavigationButton, {
    label: "Previous",
    action: ACTION_PREV,
    icon: PreviousIcon,
    renderIcon: iconPrev,
    disabled: slides.length === 0 || finite && currentIndex === 0,
    labels: labels,
    publish: publish
  }), buttonNext ? buttonNext() : React.createElement(NavigationButton, {
    label: "Next",
    action: ACTION_NEXT,
    icon: NextIcon,
    renderIcon: iconNext,
    disabled: slides.length === 0 || finite && currentIndex === slides.length - 1,
    labels: labels,
    publish: publish
  }));
};
export var NavigationModule = createModule(MODULE_NAVIGATION, Navigation);